<!-- This is a test component to display the custom fields attached
      to the blog app route -->
<template>
  <div>
    <h3>Blog Data</h3>
    <div>Format: <sc-text tag="span" :field="fields.format" /></div>
  </div>
</template>
<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-ResourceBlogData',
  props: {
    fields: {
      type: Object
    }
  },
  components: {
    ScText: Text
  }
};
</script>
